import React from "react";

import RowWrapper from "../../shared/bootstrap/RowWrapper.jsx";

import { addressSort } from "../../../util/sort.js";

export default function Addresses({ addresses }) {
  return (
    <div className="panel-body">
      {addresses
        .sort(addressSort)
        .map(({ chAddressSeq, chAddressType, address0, address1, address2, address3, city, state, zip }) => (
          <RowWrapper key={chAddressSeq}>
            <div className="col-xs-12">
              <RowWrapper>
                <div className="col-xs-12">
                  <strong>{chAddressType}</strong>
                </div>
              </RowWrapper>
              <RowWrapper>{address0 && <div className="col-xs-11 col-sm-offset-1">{address0}</div>}</RowWrapper>
              <RowWrapper>{address1 && <div className="col-xs-11 col-sm-offset-1">{address1}</div>}</RowWrapper>
              <RowWrapper>{address2 && <div className="col-xs-11 col-sm-offset-1">{address2}</div>}</RowWrapper>
              <RowWrapper>{address3 && <div className="col-xs-11 col-sm-offset-1">{address3}</div>}</RowWrapper>
              <RowWrapper>
                <div className="col-xs-11 col-sm-offset-1">{`${city}, ${state}, ${zip}`}</div>
              </RowWrapper>
            </div>
            <RowWrapper>
              <div className="col-xs-12">
                <br />
              </div>
            </RowWrapper>
          </RowWrapper>
        ))}
    </div>
  );
}
